var $ = require('jquery');
var Expiry = require('RecordExpiry');
var Labels = EY.Consultation.Labels;
var RecordAssignedTo = require('RecordAssignedTo');
var RecordDocumentationSync = require('RecordDocumentationSync');

module.exports.run = function (options) {
    var deferred = $.Deferred();
    var promise = deferred.promise();
    var skipAttachmentVerification = options.skipAttachmentVerification
    if (skipAttachmentVerification) {
        recordSave(options, deferred);
    } else {
        RecordDocumentationSync.validateAttachments(options).done(function(corruptedAttachments) {	
            if (corruptedAttachments.length == 0) {
                recordSave(options, deferred);
            }  else {
                var DialogWarning = require('DialogWarning');
                DialogWarning.show({
                    headerLabel: Labels.DialogTitleWarning,
                    saveLabel: Labels.OK,
                    message: Labels.CorruptedAttachmentMessage.replace('{0}', corruptedAttachments.toString().split(',').join('<br>'))
                }); 
            }
        })
    }
    return promise;
};

var recordSave = function(options, deferred) {
    var activities = options.activities;
    var approvers = options.approvers;
    var attachments = options.attachments;
    var fields = options.fields;
    var record = options.record;
    var pic = approvers.findWhere({ approverGroupId: 'PartnerInCharge' });

    RecordAssignedTo.run(options); // Invoking this method to make sure assignedTo & assignedToGivenName is set if they're empty

    Expiry.set(options);
    var hasRecordId = !!record.get('id');
    record.save({
        activities: activities.toJSON(),
        approvers: approvers.toJSON(),
        attachments: attachments.toJSON(),
        fields: fields.toJSON(),
        partner: !!pic ? pic.get('givenName') : ''
    }, { validate: false }).done(function () {
        if (!hasRecordId) {
            record.save(record.attributes, { validate: false }).done( function() {
                deferred.resolve(record);
                record.trigger('save', record);
            });
        } else {
            deferred.resolve(record);
            record.trigger('save', record);
        }
    }).fail(function () {
        try {
            // --SQ: To enable feature toggle for the failed-save-dialog elevate this to an ENV variable post patch!
            //if(EY.Consultation.Lookups.Configuration.ShowSaveFailedDialog) {
            var DialogWarning = require('DialogWarning');

            DialogWarning.show({
                message: Labels['ShowSaveFailedDialog']
            });
            //}
        } catch (e) { //NO-OP!
        }
    });
}


// WEBPACK FOOTER //
// ./js/Modules/Record/Service/RecordSave.js